import React from "react";
import { Link } from "react-router-dom";
import { Mic, BookOpen, Sparkles, ShieldCheck } from "lucide-react";
import MarketingPage, { PageHero } from "../../components/marketing/MarketingPage";

export default function BrandVoiceFeature() {
  return (
    <MarketingPage
      seo={{
        title: "Brand Voice — AI replies that sound like you, not a bot",
        description:
          "Train Collavue on your real assets — site, docs, past replies — and every draft sounds like the human behind your brand.",
        path: "/brand-voice-feature",
        keywords:
          "AI brand voice, custom AI tone, brand voice training, AI replies that sound human, AI tone of voice",
      }}
    >
      <PageHero
        eyebrow="Collavue · Brand Voice"
        title="Replies that sound like"
        italicWord="you."
        description="Drop in your site, docs, and a few past replies. Collavue learns your tone — punchy or polished, short or thorough — and writes every draft to match."
      >
        <Link to="/signup" className="px-6 py-3 rounded-md bg-[#0a1736] text-white font-medium hover:bg-[#1c2a4d]">
          Train your brand voice
        </Link>
      </PageHero>

      <section className="bg-white border-t border-[#e3dccb]">
        <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            { icon: Mic, title: "Tone calibrated", body: "Match your real-world voice." },
            { icon: BookOpen, title: "Knowledge grounded", body: "Drafts use your docs, not generic facts." },
            { icon: Sparkles, title: "On-brand examples", body: "Every reply learns from your last 50." },
            { icon: ShieldCheck, title: "Safe by default", body: "Forbidden phrases & competitor mentions blocked." },
          ].map((s) => (
            <div key={s.title} className="rounded-xl border border-[#e3dccb] p-6 bg-[#faf6ee]/40">
              <s.icon className="w-6 h-6 text-[#2d5bff]" />
              <h3 className="font-display text-xl text-[#0a1736] font-semibold mt-3">{s.title}</h3>
              <p className="text-[#5a6478] text-sm mt-2 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </section>
    </MarketingPage>
  );
}
